// Safe UUID generator — works on older mobile Safari (iOS < 15.4) where
// crypto.randomUUID() is undefined. Falls back to a sufficiently random
// ID for in-app React keys (no security guarantees needed).
export function uid() {
  try {
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
      return crypto.randomUUID();
    }
  } catch (_) { /* swallow and fall through */ }
  // RFC4122-ish fallback. Good enough for React keys + chat IDs.
  // Format: xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx
  const rnd = (n) => Math.floor(Math.random() * n);
  const hex = (n, len) => n.toString(16).padStart(len, "0");
  return (
    hex(rnd(0x100000000), 8) + "-" +
    hex(rnd(0x10000), 4) + "-" +
    "4" + hex(rnd(0x1000), 3) + "-" +
    hex(0x8 | rnd(4), 1) + hex(rnd(0x1000), 3) + "-" +
    hex(rnd(0x100000000), 8) + hex(rnd(0x10000), 4)
  );
}
